import styled from '@emotion/styled';

import { mq } from '@clutter/clean';

const BigText = styled.h1`
  font-family: 'Recoleta';
  letter-spacing: -0.26px;

  ${mq({ fontSize: ['32px', '56px'] })}
`;

export { BigText };
